import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3046ebc9"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-start text-xl" }, "Visibilidade para equipe médica", -1))
const _hoisted_2 = {
  key: 0,
  class: "mb-0 flex flex-col h-full overflow-hidden"
}
const _hoisted_3 = { class: "bg-grey-lighten-4 rounded-lg flex items-center" }
const _hoisted_4 = { class: "text-left flex-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Escalas", -1))
const _hoisted_6 = { class: "font-medium text-grey-darken-3" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-right flex-1 mr-3" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Visualizar escala completa")
], -1))
const _hoisted_8 = { class: "flex justify-end px-12 mb-2 mt-4" }
const _hoisted_9 = { class: "flex items-center gap-12" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm w-12 text-center" }, "App", -1))
const _hoisted_11 = {
  key: 0,
  class: "text-sm w-12 text-center"
}
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-sm w-12 text-center" }, "Compartilhar", -1))
const _hoisted_13 = { class: "flex items-center" }
const _hoisted_14 = { class: "text-left flex-1" }
const _hoisted_15 = { class: "flex items-center px-4 gap-12" }
const _hoisted_16 = { class: "w-12 flex justify-center" }
const _hoisted_17 = {
  key: 0,
  class: "w-12 flex justify-center"
}
const _hoisted_18 = { class: "w-12 flex justify-center" }
const _hoisted_19 = {
  key: 0,
  class: "mt-3 pt-3 border-t border-gray-300"
}
const _hoisted_20 = { class: "date-range-section gap-4" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "date-range-title text-[#2c3e50] text-left" }, " Período de visibilidade para médicos ", -1))
const _hoisted_22 = { class: "date-range-row" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "date-range-label" }, "De", -1))
const _hoisted_24 = ["onClick"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "date-range-icon",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  })
], -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "date-range-label" }, "Até", -1))
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "date-range-icon",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"
  })
], -1))
const _hoisted_29 = ["onClick"]
const _hoisted_30 = {
  key: 0,
  class: "bg-grey-lighten-4 rounded-lg px-4 py-4 mt-2 flex items-center justify-center text-grey-darken-1",
  style: {"background-color":"#f0f0f4"}
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Nenhuma escala encontrada para esta unidade.", -1))
const _hoisted_32 = [
  _hoisted_31
]
const _hoisted_33 = { class: "flex justify-end mt-0" }

import { ref, watch, toRefs, watchEffect, nextTick } from 'vue'
import DsSwitch from '@/components/designSystem/Switch/index.vue'
import { SimpleHealthUnitResponse } from '@/Network/Types/Responses/HealthUnitResponses'
import ModalVue from '@/components/designSystem/modals/Modal.vue'
import OutlinedButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import ScheduleService from '@/Network/Services/ScheduleUnitService'
import Spinner from '@/components/others/Spinner.vue'
import { useFeatureFlags } from '@/hooks/useFeatureFlags'
import { mdiCloseCircleOutline } from '@mdi/js'

interface Schedule {
  id: number
  name: string
  isVisible?: boolean
  isVisibleWeb?: boolean
  isShareable?: boolean
  doctorVisibleFrom?: string | null
  doctorVisibleUntil?: string | null
}


export default /*#__PURE__*/_defineComponent({
  __name: 'health.unit.schedule.visibility.modal',
  props: {
    modalStateProp: { type: Boolean },
    healthUnit: {}
  },
  emits: ['close'],
  setup(__props: any, { emit }) {

const props = __props;



const { flags } = useFeatureFlags()
const splitVisibilityEnabled = flags.enabledSplitScheduleVisibility

const scheduleService = new ScheduleService()
const schedules = ref<Schedule[]>([])
const originalSchedules = ref<Schedule[]>([])
const isLoading = ref(false)
const isUpdatingFromFetch = ref(false)

const isFullyVisible = (schedule: Schedule) =>
  splitVisibilityEnabled ? !!schedule.isVisible && !!schedule.isVisibleWeb : !!schedule.isVisible

const isFullyHidden = (schedule: Schedule) =>
  splitVisibilityEnabled ? !schedule.isVisible && !schedule.isVisibleWeb : !schedule.isVisible

async function fetchSchedules() {
  if (!props.healthUnit) return

  isLoading.value = true
  schedules.value = []
  originalSchedules.value = []
  try {
    const response = await scheduleService.list({
      healthUnitIds: [props.healthUnit.id]
    })

    const fetchedData = response.data.map((schedule) => {
      if (schedule.isVisible === false && schedule.isShareable === true) {
        return {
          ...schedule,
          isShareable: false
        }
      }
      return schedule
    })

    schedules.value = fetchedData
    originalSchedules.value = JSON.parse(JSON.stringify(response.data))

    isUpdatingFromFetch.value = true
    fullScheduleVisibility.value = response.data.every(isFullyVisible)

    await nextTick()
    isUpdatingFromFetch.value = false
  } catch (error) {
    console.error('Falha ao buscar escalas', error)
  } finally {
    isLoading.value = false
  }
}


const { modalStateProp } = toRefs(props)

const close = () => {
  saveChanges()
  emit('close')
}

const fullScheduleVisibility = ref(true)

watch(fullScheduleVisibility, (newValue) => {
  if (isUpdatingFromFetch.value) return

  schedules.value = schedules.value.map((escala) => ({
    ...escala,
    isVisible: newValue,
    ...(splitVisibilityEnabled ? { isVisibleWeb: newValue } : {})
  }))
})

watch(
  schedules,
  (newSchedules) => {
    if (isUpdatingFromFetch.value) return

    if (newSchedules.every(isFullyVisible)) {
      fullScheduleVisibility.value = true
    } else if (newSchedules.every(isFullyHidden)) {
      fullScheduleVisibility.value = false
    }

    newSchedules.forEach((schedule) => {
      if (schedule.isVisible === false && schedule.isShareable === true) {
        schedule.isShareable = false
      }
    })
  },
  { deep: true }
)

watchEffect(() => {
  if (props.modalStateProp) {
    fetchSchedules()
  } else {
    schedules.value = []
    originalSchedules.value = []
  }
})

function formatDateDisplay(value: string | null | undefined): string {
  if (!value) return ''
  const [year, month, day] = value.split('-')
  return `${day}/${month}/${year}`
}

function toDateString(date: Date): string {
  const y = date.getFullYear()
  const m = String(date.getMonth() + 1).padStart(2, '0')
  const d = String(date.getDate()).padStart(2, '0')
  return `${y}-${m}-${d}`
}

function parseDate(value: string | null | undefined): Date | null {
  if (!value) return null
  const [year, month, day] = value.split('-').map(Number)
  return new Date(year, month - 1, day)
}

function getDateRange(schedule: Schedule): { start: Date | null; end: Date | null } {
  return {
    start: parseDate(schedule.doctorVisibleFrom),
    end: parseDate(schedule.doctorVisibleUntil)
  }
}

function updateDateRange(schedule: Schedule, val: { start: Date; end: Date } | null) {
  if (!val) {
    schedule.doctorVisibleFrom = null
    schedule.doctorVisibleUntil = null
    return
  }
  schedule.doctorVisibleFrom = toDateString(val.start)
  schedule.doctorVisibleUntil = toDateString(val.end)
}

function clearDoctorDates(schedule: Schedule) {
  schedule.doctorVisibleFrom = null
  schedule.doctorVisibleUntil = null
}

const VISIBILITY_KEYS: (keyof Schedule)[] = ['isVisible', 'isShareable']
const SPLIT_VISIBILITY_KEYS: (keyof Schedule)[] = [
  'isVisibleWeb',
  'doctorVisibleFrom',
  'doctorVisibleUntil'
]

function hasScheduleChanged(schedule: Schedule, original: Schedule): boolean {
  const keys = splitVisibilityEnabled
    ? [...VISIBILITY_KEYS, ...SPLIT_VISIBILITY_KEYS]
    : VISIBILITY_KEYS
  return keys.some((k) => (schedule[k] ?? null) !== (original[k] ?? null))
}

function buildUpdatePayload(schedule: Schedule) {
  const payload: Record<string, unknown> = {
    isVisible: schedule.isVisible,
    isShareable: schedule.isShareable
  }
  if (splitVisibilityEnabled) {
    payload.isVisibleWeb = schedule.isVisibleWeb
    payload.doctorVisibleFrom = schedule.doctorVisibleFrom ?? null
    payload.doctorVisibleUntil = schedule.doctorVisibleUntil ?? null
  }
  return payload
}

async function saveChanges() {
  const promises: Promise<any>[] = []

  schedules.value.forEach((schedule) => {
    const original = originalSchedules.value.find((o) => o.id === schedule.id)

    if (original && hasScheduleChanged(schedule, original)) {
      promises.push(scheduleService.update(schedule.id, buildUpdatePayload(schedule)))
    }
  })

  if (promises.length > 0) {
    try {
      await Promise.all(promises)
      originalSchedules.value = JSON.parse(JSON.stringify(schedules.value))
    } catch (error) {
      console.error('Falha ao salvar mudanças', error)
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_VDatePicker = _resolveComponent("VDatePicker")!

  return (_openBlock(), _createBlock(ModalVue, {
    onClose: close,
    modalActive: _unref(modalStateProp)
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_33, [
        _createVNode(OutlinedButton, {
          onClick: close,
          text: "Fechar",
          width: "100px"
        })
      ])
    ]),
    default: _withCtx(() => [
      (_ctx.healthUnit)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (isLoading.value)
              ? (_openBlock(), _createBlock(Spinner, {
                  key: 0,
                  color: "primary",
                  size: "5rem",
                  width: "0.5rem",
                  class: "absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-50"
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["flex-shrink-0", { 'opacity-50': isLoading.value }])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.healthUnit.name), 1)
                ]),
                _hoisted_7,
                _createVNode(DsSwitch, {
                  modelValue: fullScheduleVisibility.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fullScheduleVisibility).value = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  (_unref(splitVisibilityEnabled))
                    ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Painel"))
                    : _createCommentVNode("", true),
                  _hoisted_12
                ])
              ])
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["flex-1 overflow-y-auto min-h-0", { 'opacity-50': isLoading.value }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(schedules.value, (schedule) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: schedule.id,
                  class: "bg-grey-lighten-4 rounded-lg px-4 py-3 mt-3",
                  style: {"background-color":"#f0f0f4"}
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("p", {
                        class: _normalizeClass(["text-xs", !schedule.isVisible ? 'text-[#9E9EB7]' : '#16161D'])
                      }, " Escala: ", 2),
                      _createElementVNode("p", {
                        class: _normalizeClass(["font-bold", !schedule.isVisible ? 'text-[#9E9EB7]' : '#16161D'])
                      }, _toDisplayString(schedule.name), 3)
                    ]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(DsSwitch, {
                          "model-value": !!schedule.isVisible,
                          "onUpdate:modelValue": (val) => (schedule.isVisible = val)
                        }, null, 8, ["model-value", "onUpdate:modelValue"])
                      ]),
                      (_unref(splitVisibilityEnabled))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(DsSwitch, {
                              "model-value": !!schedule.isVisibleWeb,
                              "onUpdate:modelValue": (val) => (schedule.isVisibleWeb = val)
                            }, null, 8, ["model-value", "onUpdate:modelValue"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(DsSwitch, {
                          "model-value": !!schedule.isShareable,
                          "onUpdate:modelValue": (val) => (schedule.isShareable = val),
                          disabled: !schedule.isVisible
                        }, null, 8, ["model-value", "onUpdate:modelValue", "disabled"])
                      ])
                    ])
                  ]),
                  (_unref(splitVisibilityEnabled) && schedule.isVisible)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _hoisted_21,
                          _createVNode(_component_VDatePicker, {
                            "model-value": getDateRange(schedule),
                            "onUpdate:modelValue": 
                  (val) => updateDateRange(schedule, val)
                ,
                            "is-range": "",
                            locale: "pt-BR",
                            "first-day-of-week": 2
                          }, {
                            default: _withCtx(({ togglePopover }) => [
                              _createElementVNode("div", _hoisted_22, [
                                _hoisted_23,
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "date-range-btn",
                                  onClick: togglePopover
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass({ 'text-gray-400': !schedule.doctorVisibleFrom })
                                  }, _toDisplayString(formatDateDisplay(schedule.doctorVisibleFrom) || 'Selecionar'), 3),
                                  _hoisted_25
                                ], 8, _hoisted_24),
                                _hoisted_26,
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "date-range-btn",
                                  onClick: togglePopover
                                }, [
                                  _createElementVNode("span", {
                                    class: _normalizeClass({ 'text-gray-400': !schedule.doctorVisibleUntil })
                                  }, _toDisplayString(formatDateDisplay(schedule.doctorVisibleUntil) || 'Selecionar'), 3),
                                  _hoisted_28
                                ], 8, _hoisted_27),
                                (schedule.doctorVisibleFrom || schedule.doctorVisibleUntil)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 0,
                                      type: "button",
                                      class: "date-range-clear-btn",
                                      title: "Limpar datas",
                                      onClick: _withModifiers(($event: any) => (clearDoctorDates(schedule)), ["stop"])
                                    }, [
                                      _createVNode(_component_v_icon, {
                                        icon: _unref(mdiCloseCircleOutline),
                                        size: "22",
                                        color: "#9E9EB7"
                                      }, null, 8, ["icon"])
                                    ], 8, _hoisted_29))
                                  : _createCommentVNode("", true)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["model-value", "onUpdate:modelValue"])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              (!isLoading.value && schedules.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
                : _createCommentVNode("", true)
            ], 2)
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})